import { SlideBucketCard } from './slide-bucket-card.model';

export class SlideBucketsDTO {
  id?: string;
  title?: string;
  cards?: SlideBucketCard[];
}
